var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateDeficiency as updateDeficiencyService } from '../services/DeficiencyServices';
export default function useUpdateDeficiencyDetail() {
    const queryClient = useQueryClient();
    const updateDeficiency = useMutation(({ id, deficiencyUpdate }) => updateDeficiencyService(id, deficiencyUpdate), {
        // If mutation fails, use the context returned from onMutate to roll back
        onError: (err, { id }, context) => {
            if (context === null || context === void 0 ? void 0 : context.previousDeficiency) {
                queryClient.setQueryData(['deficiency', id], context.previousDeficiency);
            }
        },
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ id, deficiencyUpdate }) {
            yield queryClient.cancelQueries(['deficiency', id]);
            const previousDeficiency = queryClient.getQueryData(['deficiency', id]);
            queryClient.setQueryData(['deficiency', id], (old) => (Object.assign(Object.assign({}, old), deficiencyUpdate)));
            return { previousDeficiency };
        }),
        // Always refetch after error or success:
        onSettled: (_data, _error, { id }) => {
            void queryClient.invalidateQueries(['deficiency', id]);
        },
        onSuccess: (updatedDeficiency) => {
            queryClient.setQueryData(['deficiency', updatedDeficiency.id], updatedDeficiency);
        }
    });
    return { updateDeficiency };
}
